import { render, staticRenderFns } from "./InformationDrawer.vue?vue&type=template&id=a38987d8&scoped=true&"
import script from "./InformationDrawer.vue?vue&type=script&lang=js&"
export * from "./InformationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./InformationDrawer.vue?vue&type=style&index=0&id=a38987d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38987d8",
  null
  
)

export default component.exports